// pages/AssetsFormPage/PdfCanvasViewer.jsx
import { useEffect, useRef } from 'react';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js';

// NÃO importe 'pdfjs-dist/web/pdf_viewer.css' aqui.
// Aquele CSS é do viewer completo e puxa ícones (SVGS) que quebram no CRA.

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

export default function PdfCanvasViewer({ fileUrl, page = 1, onReady }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    let pdfDoc = null;
    let cancelled = false;

    const render = async () => {
      try {
        const loadingTask = pdfjsLib.getDocument({
          url: fileUrl,
          disableStream: true,
          disableAutoFetch: true,
        });
        pdfDoc = await loadingTask.promise;
        if (cancelled) return;

        onReady?.({ numPages: pdfDoc.numPages });

        const pg = Math.max(1, Math.min(page, pdfDoc.numPages));
        const pdfPage = await pdfDoc.getPage(pg);
        if (cancelled) return;

        const viewport = pdfPage.getViewport({ scale: 1.5 });
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        canvas.width = Math.floor(viewport.width);
        canvas.height = Math.floor(viewport.height);

        const renderContext = { canvasContext: ctx, viewport };
        await pdfPage.render(renderContext).promise;
      } catch (e) {
        console.error('[PdfCanvasViewer] erro ao carregar/renderizar PDF:', e);
      }
    };

    render();
    return () => { cancelled = true; };
  }, [fileUrl, page, onReady]);

  return <canvas ref={canvasRef} style={{ width: '100%', height: 'auto', display: 'block' }} />;
}
